import React from "react";
import SlideRejoindre from "../../components/slideRejoindre";
import JobList from "../../components/jobList";
import ActualitesHome from "../../components/actualitesHome";
import SliderR from "../../components/slider";
import Newsletter from "../../components/newsletter";
const RejoindrePage = () => {
  return (
    <div>
      <SlideRejoindre />
      <JobList />
      <ActualitesHome />
      <SliderR />
      <Newsletter />
    </div>
  );
};

export default RejoindrePage;
